module.exports = __webpack_public_path__ + "img/teaching_8.28e851d1.png";